import {TextField, InputLabel} from '@mui/material';
import React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import {useField, ErrorMessage, useFormikContext } from 'formik';


interface Props {
  name: string;
  inputLabel: string;
  className: string;
  placeholder:string;
  endTimeError?:boolean;
}
const TimePickerWrapper: React.FC<Props> = ({
  inputLabel,
  name,
  placeholder,
  endTimeError
}) => {
  const { setFieldValue} = useFormikContext();
  const [field, meta] = useField(name);
  const [value1, setValue] = React.useState<null>(null);

  const changeHandler = (newValue:any)=> {
    setValue(newValue);
    setFieldValue(name, newValue)
  }
 
  const placeholdertext = {
    inputProps:{
      placeholder: placeholder
    }
  }

  return (
    <>
      <InputLabel htmlFor="grouped-native-select"
         className={
            meta && meta.touched && meta.error ? "error-color label datetimepickerlabel" : "label datetimepickerlabel"
          }
      >
        {inputLabel} <span style={{color:'red'}}>*</span></InputLabel>      
        <LocalizationProvider  dateAdapter={AdapterMoment }>
      <TimePicker
       {...placeholdertext}
        value={value1}
        onChange={changeHandler}
        renderInput={(params) => 
        <TextField 
          {...params} 
          error={meta && meta.touched && meta.error? true: false}
           />
        }
      />
    </LocalizationProvider>
    {meta && meta.touched && meta.error ?
       <ErrorMessage component='p' name={name}   className = "select-error error-color fs-14"/>
       : null
    }
    {(endTimeError && name==='endTime') &&  <small  className = "select-error error-color fs-14">End Time must be greater then start time</small>}
    </>
  );
};

export default TimePickerWrapper;
